import React from "react";
import TechBadge from "./TechBadge";

const PositionCard = ({
  position,
  removePosition, // OpenPositions için (çöp kutusu)
  onRemove, // Yeni Eklenen Pozisyonlar için (çarpı)
}) => {
  console.log("PositionCard techs:", position.techs);
  return (
    <div className="relative flex h-[76px] justify-between items-center rounded-xl">
      <div className="h-[76px] flex flex-col justify-between">
        <h3 className="text-dark font-semibold text-base">{position.title}</h3>
        <div className="flex gap-2 mt-2">
          {position.techs.map((tech, index) => (
            <TechBadge
              key={tech.id || `tech-${position._id}-${index}`} // Güvenli key
              tech={tech.name}
            />
          ))}
        </div>
      </div>

      {/* Koşullu Silme Butonu */}
      {removePosition && (
        <button
          onClick={() => removePosition(position)}
          className="btn-transparent absolute top-0 right-0 p-0"
          aria-label={`Remove ${position.title}`} // Erişilebilirlik
        >
          <img
            src="/sil.svg"
            alt="sil"
            className="w-[24px] h-[24px]"
          />
        </button>
      )}

      {onRemove && (
        <button
          onClick={onRemove}
          className="absolute top-0 right-0 text-grayy"
          aria-label={`Remove ${position.title}`} // Erişilebilirlik
        >
          ✖
        </button>
      )}
    </div>
  );
};

export default PositionCard;